export interface ACHPayment {
  entityName: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  accountNumberConfirm: string;
  voidedCheckFile: string | null;
  voidedCheckFileName: string;
  voidedCheckFileType: string;
  voidedCheckFileId: string | null;
  optIn: boolean | null;
  acknowledgedTerms: boolean;
}

/**
 * Creates a default ACHPayment object
 */
export function createDefaultACHPayment(): ACHPayment {
  return {
    entityName: "",
    bankName: "",
    routingNumber: "",
    accountNumber: "",
    accountNumberConfirm: "",
    voidedCheckFile: null,
    voidedCheckFileName: "",
    voidedCheckFileType: "",
    voidedCheckFileId: null,
    optIn: null,
    acknowledgedTerms: false
  };
}